import React from 'react'

function ExperiencesDetails(props) {
  return (
    <div className="row">
        <div className="col-md-6">
            <div className="experiences-single-details" data-aos="fade-right" data-aos-duration="800">
                <div className="experiences-date">
                    <p> May 2023  — Present  </p>
                </div>
                <h3>Front-end Developer at Amaito Soft–Remote</h3>
                <div className="details-part">
                    <ul>
                        <li>Proficient in React JS, JavaScript, Python, Bootstrap, Tailwind, CSS.
</li>
                        <li>Developed and maintained responsive web applications using React JS. Implemented Redux, resulting in a 20% increase in user engagement.</li>
                        <li>Collaborated with designers and backend developers to integrate front-end components and enhance user experience.</li>
                        <li>Collaborated with cross-functional teams to deliver high-quality user interfaces.</li>
                        <li>Utilized problem-solving skills to debug code and optimize performance.</li>
                    </ul>
                </div>
            </div>
        </div>
        <div className="col-md-6">
            <div className="experiences-single-details" data-aos="fade-right" data-aos-duration="800">
                <div className="experiences-date">
                    <p> May 2022  — September 2022  </p>
                </div>
                <h3>Web Developer Intern at Interactive Cares–Remote</h3>
                <div className="details-part">
                    <ul>
                        <li>Front-end web application development with React JS, Javascript.</li>
                        <li>Use of web services, HTML5 ,CSS3, JavaScript, React..</li>
                        <li>Conversion of designs into fully responsive web pages.</li>
                        <li>Conversion PSD to HTML, Figma to HTML.</li>
                        <li>Working with a team.</li>
                        <li>Working on the executive panel. </li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
  )
}

export default ExperiencesDetails